module.exports = __webpack_public_path__ + "static/media/scrubblitz-1.14cd8997.jpg";